import { Back2 } from "../../../components/Option/Back";
import EditableResultDropdown from "../../../components/EditableResultDropdown";
import gearicon from "../../../assets/shapes_svg/ambition/gearicon.svg";
import { ContainerBody } from "../../../App";
import SME from "./SME";
import CompanyEmissions from "./CompanyEmissions";
import TargetValidation from "./TargetValidation";
import {
  createHighlight,
  getHighlight,
  updateHighlight,
} from "../../../apis/Ambition";
import "../index.css";
import "./index.css";

import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { useState, useEffect } from "react";

export const CustomCheckbox = (states) => {
  // only can choose one option
  let newTarget = "";
  const handleChange = (index) => {
    // if(checkStates()){
    //     return;
    // }

    const newStates = states.states.map((oldState) => {
      if (oldState.id === index && !oldState.checked) {
        newTarget = oldState.name;
        return { id: oldState.id, name: oldState.name, checked: true };
      }
      return { id: oldState.id, name: oldState.name, checked: false };
    });

    states.setStates(newStates);
    states.setTarget(newTarget);
  };

  return (
    <div className="custom__checkbox">
      {states.title !== "" ? (
        <h5 className="custom__label">{states.title}</h5>
      ) : null}
      <FormGroup>
        {states.states.map((state, index) => {
          return (
            <FormControlLabel
              control={<Checkbox color="success" />}
              label={<h5 className="custom__label">{state["name"]}</h5>}
              onChange={() => handleChange(index + 1)}
              checked={state.checked}
            />
          );
        })}
      </FormGroup>
    </div>
  );
};

const SBTi = () => {
  const [baseline, setBaseline] = useState("");
  const [target, setTarget] = useState("");

  const fields = [
    { name: "baselinesbti", setValue: setBaseline },
    { name: "targetsbti", setValue: setTarget },
  ];

  const [dropdownBaseline, setDropdownBaseline] = useState([
    { id: 1, name: "2018", value: "2018" },
    { id: 2, name: "2019", value: "2019" },
    { id: 3, name: "2020", value: "2020" },
    { id: 4, name: "2021", value: "2021" },
    { id: 5, name: "Other", value: "Other" },
  ]);
  const [dropdownTarget, setDropdownTarget] = useState([
    {
      id: 1,
      name: "Setting new or updating existing near-term targets new or updating",
      checked: false,
    },
    { id: 2, name: "Setting only net-zero targets", checked: false },
    {
      id: 3,
      name: "Setting new or updating existing near-term targets AND submitting net-zero targets",
      checked: false,
    },
    {
      id: 4,
      name: "Setting new near-term maintenance targets",
      checked: false,
    },
  ]);

  const updateField = ({ action = "update", editField, valueName, value }) => {
    if (editField !== false) {
      return;
    }

    if (action !== "update") {
      createHighlight({ key: valueName, value: value });
    } else {
      updateHighlight({
        key: valueName,
        value: value,
        swal: false,
      });
    }
  };

  useEffect(() => {
    fields.map((field) => {
      getHighlight({
        key: field.name,
        setValue: field.setValue,
      });
    });
  }, []);

  useEffect(() => {
    if (baseline !== "Other" && baseline !== "") {
      updateField({
        editField: false,
        valueName: "baselinesbti",
        value: baseline,
      });
    }
  }, [baseline]);

  useEffect(() => {
    if (target !== "") {
      updateField({
        editField: false,
        valueName: "targetsbti",
        value: target,
      });
    }
  }, [target]);

  const tip = (
    <>
      <b>Tip</b>
      <br />
      STBi are based on the results from your scope 1 and 2 reporting. So if you
      havn't completed these yet, we recommend to do that first
    </>
  );

  const smeDef = (
    <>
      <b>STBi definition of a SME:</b>
      <br />
      Companies and public sector institutions with fewer than 500 employees,
      not including Financial Institutions (FIs) and Oil & Gas (O&G) companies.
    </>
  );

  const sbtiDef = (
    <>
      The Science Based Targets (SBT) Initiative is a global effort that
      empowers businesses to take meaningful action against climate change.
      Launched in 2015, this collaborative initiative brings together leading
      environmental organisations, including CDP, the United Nations Global
      Compact (UNGC), the World Resources Institute (WRI), and the World Wide
      Fund for Nature (WWF).
      <br />
      <br />
      With the understanding that businesses play a pivotal role in driving
      greenhouse gas emissions, the SBT Initiative aims to align corporate
      climate targets with the latest scientific research. It recognises that
      the reduction of emissions is not only a moral imperative but also a
      strategic opportunity for companies to create a sustainable and resilient
      future.
      <br />
      The SBT Initiative provides a comprehensive framework that guides
      companies in setting science-based targets to limit global warming. By
      incorporating the latest findings from the Intergovernmental Panel on
      Climate Change (IPCC), companies can ensure that their emissions reduction
      efforts are in line with the goals outlined in the Paris Agreement.
      <br />
      To qualify as science-based, targets are rigorously evaluated against
      predefined criteria. They must be ambitious, consistent with the best
      available science, and contribute to keeping global temperature rise well
      below 2 degrees Celsius above pre-industrial levels. Targets can focus on
      emissions reductions within a company's own operations (Scope 1 and 2), as
      well as across its value chain (Scope 3), capturing a comprehensive view
      of emissions.
      <br />
      By embracing science-based targets, companies not only demonstrate their
      commitment to combatting climate change but also position themselves as
      leaders in sustainability and responsible corporate citizenship. The
      adoption of such targets helps companies drive innovation, enhance
      operational efficiency, and build resilience in the face of
      climate-related risks. <br />
      Moreover, science-based targets provide companies with a clear roadmap for
      their transition to a low-carbon economy. By setting goals that are
      grounded in science, companies can make informed decisions, invest in
      renewable energy, adopt sustainable practices, and explore new business
      models that drive positive environmental and social outcomes. <br />
      The Science Based Targets Initiative is transforming the way businesses
      approach climate action, fostering a collective effort to tackle the
      global climate crisis. Through this initiative, companies are empowered to
      make a tangible and measurable impact, contributing to a sustainable and
      thriving future for all.
      <br /> <br />
    </>
  );

  const sbtiDef2 = (
    <>
      All companies, regardless of their sector or industry, are encouraged to
      participate in the Science Based Targets (SBT) Initiative. <br /> <br />
      The Science Based Targets (SBT) Initiative is open to a wide range and
      size of companies across sectors, including financial institutions, joint
      ventures, cooperatives, and state-owned enterprises. However oil and gas
      companies are still not included in the initiative since their targets
      still need to be officially validated. <br /> <br />
      The initiative recognises that addressing climate challenges requires a
      collaborative effort across industries, and thus welcomes the
      participation of businesses and organisations from around the world.{" "}
      <br /> <br />
      Science Based Targets Initiative (SBTi) are currently not evaluating
      targets for cities, local governments, public sector institutions with
      over 500 employees, educational institutions, or non-profit organisations.
      However, both the SBTi and we ate YFS encourage these stakeholders to
      adopt SBT-setting methodologies when independently developing climate
      targets. <br />
      <br />
    </>
  );

  const sbtiDef3 = (
    <>
      The STBi has created a simplified, but not less ambitious, online
      application process for setting science-based targets exclusively for
      small and medium-sized enterprises (SMEs). In this way, the road for SMEs
      to apply for STBi has become shorter, less complicated and less
      time-consuming. <br />
      <br />
      The YFS framework for setting science based targets is following the STBi
      SME route, making sure that all necessary data are collected, so that
      when/if your company wishes to make an official commitment to the STBi,
      you will have gathered all necessary data.
      <br />
      <br />
      This means that if you are representing a company or institution larger
      than 500 employees, you are not to use the YFS framework. Instead you have
      to commit though the official{" "}
      <a
        href="https://sciencebasedtargets.org/step-by-step-process"
        target="_blank"
        rel="noreferrer"
      >
        SBTi standard commitment and target validation process.
      </a>
      <br />
      <br />
    </>
  );

  const sbtiGraphDef = (
    <>
      The graphic illustrates how the SME commitment and target validation
      process are different from the standard procedure. As illustrated the SME
      route is bypassing the first two steps by streamlining the validation
      process and for the user to immediately set near-term science-basted
      targets.
      <br />
      <br />
      Setting targets in line with SBTi in the YFS framework you will be able to
      see the actual CO2e reductions which need to be met by 2030 in order to
      comply with the target(s) formulated by the STBi - and hereby in line with
      the latest climate science.
      <br />
      <br />
      Note that you have to spend at least USD 9.500 (prize of one target) to be
      an official member of the STBi.
      <br />
      We at YFS believe that any company big or small should have the option to
      commit to science-based targets in line with the initiative, without
      having to spend big money. So if this is your ambition, let's get started
      here!
      <br />
    </>
  );

  const nearTermDef = (
    <>
      <b>Target-specific information</b>
      <br />
      Based on SBTi Criteria 5.0, which has been in effect since July 15th 2022,
      the following predefined target options have been modified to reflect the
      level of decarbonization required to keep global temperature increase to
      1.5°C. Criterion 16 focuses on the choice of base years after or equal to
      2020, and specifies that absolute emission reductions must meet a minimum
      contraction rate based on a target year of 2020, as indicated in the
      formula below: <br />
      <br />
      <strong>
        Minimum absolute contraction target value = 4.2% x (Target year - base
        year).
      </strong>
      <br />
      For base years between 2018 and 2019 (inclusive), the absolute emissions
      reduction meets the minimum reduction value over the target period as set
      out below: <br />
      <br />
      <strong>
        Minimum value for absolute contraction target = 4.2% x (Target year -
        2020)
      </strong>
      <br />
      Consequently, to ensure alignment with 1.5C ambition, SMEs must meet, at a
      minimum, between base years after or equal to 2020 and 2030, a level of
      emissions reductions equivalent to 42%. Based on this, the updated
      reduction rates are as follows:
    </>
  );

  const commitDef = (
    <>
      If you have filled in all the required information and accepted the
      validations requirement, you are all set to apply for the SBTi.
      <br />
      <br />
      You basically have to fill in exactly the same information as in this
      framework. Finish the online applications process here:{" "}
      <a
        href="https://form.jotform.com/targets/sme-target-validation"
        target="_blank"
        rel="noreferrer"
      >
        SME route
      </a>
      .
    </>
  );

  return (
    <ContainerBody className="ambition__body">
      <div
        className="companydetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Company Page"}
          style={{ marginRight: "auto", position: "relative", left: "-7%" }}
          to={"/ambition"}
        />
      </div>
      <div className="ambition__esg__items">
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
            alignItems: "flex-start",
          }}
        >
          <div>
            <div>
              <div
                className="ambition__body__item"
                style={{
                  padding: "10px",
                  justifyContent: "space-between",
                  width: "180px",
                  height: "210px",
                  textAlign: "center",
                  marginTop: "10%",
                }}
              >
                <h4 style={{ marginTop: "5px" }}>SBTi</h4>
                <h5>Science Based Targets initiative</h5>
                <img src={gearicon} alt="Gear Icon" />
              </div>
            </div>
            <div style={{ marginTop: "30vh" }}>
              <div
                className="ambition__body__item"
                style={{
                  padding: "10px",
                  justifyContent: "center",
                  width: "180px",
                  textAlign: "center",
                  marginTop: "2%",
                  alignItems: "center",
                }}
              >
                <h5>
                  Read more about STBi{" "}
                  <a
                    href="https://sciencebasedtargets.org/how-it-works"
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                </h5>
              </div>
              <div
                className="ambition__body__item"
                style={{
                  padding: "10px",
                  justifyContent: "space-between",
                  width: "180px",
                  textAlign: "center",
                  marginTop: "30vh",
                }}
              >
                <h5>{tip}</h5>
              </div>
              <div
                className="ambition__body__item"
                style={{
                  padding: "10px",
                  justifyContent: "space-between",
                  width: "180px",
                  height: "300px",
                  textAlign: "center",
                  marginTop: "30vh",
                }}
              >
                <h5>{smeDef}</h5>
              </div>
            </div>
          </div>

          <div className="roleambition__bubble">
            <h4>
              <b>What are Science Based Targets initiative?</b>
            </h4>
            <h5>{sbtiDef}</h5>
            <h4>
              <b>Who can join?</b>
            </h4>
            <h5>{sbtiDef2}</h5>
            <h4>
              <b>Want to get started?</b>
            </h4>
            <h5>{sbtiDef3}</h5>
          </div>
        </div>
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div className="roleambition__bubble">
            <h4>
              <b>Validation process for large enterprises vs. SME's</b>
            </h4>
            <h5>{sbtiGraphDef}</h5>
            <div className="sbti__fields" style={{ marginTop: "5vh" }}>
              <h5 className="sbti__labels" style={{ textAlign: "center" }}>
                What are the baseline for your scope 1 and 2 emissions?
              </h5>
              <div className="sbit__inputs w-40">
                <EditableResultDropdown
                  result={baseline}
                  edit={true}
                  changeTo={baseline}
                  setValue={setBaseline}
                  setBusinessSize={setBaseline}
                  dropdown={dropdownBaseline}
                  autosave={true}
                  styleNo={3}
                  withBackground={true}
                />
                {baseline === "Other" ? (
                  <h6 style={{ textAlign: "center", margin: "10px" }}>
                    According to the validation requirement your scope 1 and 2
                    data can't be older than 2018
                  </h6>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div>
          <h4 className="sdg__headersection" style={{ left: "12vw" }}>
            SME application
          </h4>
        </div>
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "center",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div
            className="ambition__body__item"
            style={{
              padding: "10px",
              width: "150px",
              textAlign: "center",
              cursor: "auto",
            }}
          >
            <h5>
              Need help? Reach out to one of our consultants{" "}
              <u>
                <strong>here</strong>
              </u>
            </h5>
          </div>
          <div className="roleambition__bubble" style={{ width: "80%" }}>
            <SME />
          </div>
        </div>
        <div>
          <h4 className="sdg__headersection">Target Selection</h4>
        </div>
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div className="roleambition__bubble" style={{ textAlign: "center" }}>
            <CustomCheckbox
              states={dropdownTarget}
              setStates={setDropdownTarget}
              title="What kind of targets are you submitting for validation?"
              target={target}
              setTarget={setTarget}
            />
          </div>
        </div>
        <div>
          <h4 className="sdg__headersection">What is Near Term?</h4>
        </div>
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div className="roleambition__bubble font-italic">
            <h5>{nearTermDef}</h5>
          </div>
        </div>
        <div>
          <h4 className="sdg__headersection">
            What kind of targets are you submitting for validation?
          </h4>
        </div>
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div className="roleambition__bubble">
            <TargetValidation />
          </div>
        </div>
        <div>
          <h4 className="sdg__headersection">
            Company’s emissions profile (Scope 1 and 2)
          </h4>
        </div>
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div className="roleambition__bubble">
            <CompanyEmissions />
          </div>
        </div>
        <div>
          <h4 className="sdg__headersection">
            Officially commit to the target
          </h4>
        </div>
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div className="roleambition__bubble">
            <h5>{commitDef}</h5>
          </div>
        </div>
      </div>
    </ContainerBody>
  );
};

export default SBTi;
